module.exports = __webpack_public_path__ + "img/worldmap-1280.d6d2eedf.png";